export default "__VITE_ASSET__Bo8vDHn4__"